/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetOrganizationRemoteSessionIssuerRequest = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetOrganizationRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetOrganizationRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerSecurity$Outbound,
    GetOrganizationRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerSecurityToJSON(
  getOrganizationRemoteSessionIssuerSecurity:
    GetOrganizationRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerSecurity$outboundSchema.parse(
      getOrganizationRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationRemoteSessionIssuerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const GetOrganizationRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationRemoteSessionIssuerRequest$Outbound,
    GetOrganizationRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
      });
    }),
  );

export function getOrganizationRemoteSessionIssuerRequestToJSON(
  getOrganizationRemoteSessionIssuerRequest:
    GetOrganizationRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    GetOrganizationRemoteSessionIssuerRequest$outboundSchema.parse(
      getOrganizationRemoteSessionIssuerRequest,
    ),
  );
}
